module.exports = __webpack_public_path__ + "static/img/NL@2x.2c7515b8.jpg";